import React, { useEffect, useState } from 'react'
import './Payment.css'
import { useStateValue } from './StateProvider';
import CheckoutProduct from './CheckoutProduct';
import { Link, useHistory } from "react-router-dom";
import { CardElement ,useElements, useStripe } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import { getBasketTotal } from './reducer';
import axios from './axios';
import { db } from './firebase';


function Payment() {
    const [{ basket, user }, dispatch] =useStateValue();
    const history = useHistory();

    const stripe = useStripe();
    const elements = useElements();

    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [clientSecret, setClientSecret] = useState("");

    useEffect(() => {
        // generate the special secret which allows 
        // us to change a customer

        const getClientSecret = async () => {
            const response = await axios({
                method: 'post',
                // stripe expects the total in a currencies subunits
                url: `/payments/create?total=${getBasketTotal(basket) * 100}`
            });
            setClientSecret(response.data.clientSecret)
        }

        getClientSecret();
    }, [basket])

    console.log('THE SECRET IS >>>', clientSecret)

    const handleSubmit = async (event) => {
        // do all the fancy stripe stuff......
        event.preventDefault();
        setProcessing(true);

        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement)
            }
        }).then(({paymentIntent}) => {
            
            console.log(paymentIntent)
            // if(result.error) {
            //     console.log("You are having this error", result.error)
            // }

            // else {
            //     console.log(result.paymentIntent)
            
            // paymentIntent = payment confirmation
            
            db
                .collection('users') 
                .doc(user?.email)
                .collection('orders')
                .doc(paymentIntent.id)
                .set({
                    basket: basket,
                    amount: paymentIntent.amount,
                    created: paymentIntent.created
                })

            setSucceeded(true);
            setError(null);
            setProcessing(false);

            dispatch({
                type: 'EMPTY_BASKET'
            })

            history.replace('/orders')
            
        })
    
    }

    const handleChange = event => {
        // Listen for changes in the CardElement
        // and display any errors as the customer types their card details
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    }

    
    return (
        <div className='payment'>
            <div className='payment__container'>
                <h1>
                    Checkout (<Link to="/checkout">{basket?.length} items</Link>)
                </h1>
                {/* Payment section - Review Items */}
                <div className='payment__section'>
                    <div className='payment__title'>
                        <p>Hello, {user?.email}</p>
                    </div>
                </div>
                {/* Payment section - Payment method */}
                <div className='payment__section'>
                    <h3 className='review'>Review Table</h3>
                    <div className='payment__items'>
                        {basket.map(item => (
                            <CheckoutProduct 
                                id={item.id}
                                title={item.title}
                                image={item.image}
                                price={item.price}
                            />
                        ))}
                    </div>
                </div>
                {/* Payment section */}
                <div className='payment__section'>
                    <h3 className='pmt_mtd'>Payment Method</h3>
                    <div className='payment__details'>
                        {/* Stripe magic will go here */}

                        <form onSubmit={handleSubmit}>
                            <CardElement onChange={handleChange}/>

                            <div className='payment__priceContainer'>
                            <CurrencyFormat
                                renderText={(value) => (
                                    
                                    <h3>Order Total: {value}</h3>
                                    
                                    
    
                                )}
                                decimalScale={2}
                                value={getBasketTotal(basket)} 
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"₹"}
                            />
    
                            <button
                                disabled={processing || disabled || 
                                succeeded}>
                                <span>{processing ? <p>Processing</p>:
                                "Buy Now"}</span>
                            </button>
                            
                            
                            </div>
                            
                            {error && <div>{error}</div>} 
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Payment
